import { jsx as _jsx } from "react/jsx-runtime";
export function TableClickBoundary(props) { const enabled = props.enabled !== false; return /*#__PURE__*/ _jsx("div", { "data-ignore-clicks": enabled, onClick: e => { if (enabled) {
        e.stopPropagation();
    } }, children: props.children }); }
